import React, { createContext, useContext } from "react"

/**
 * @typedef {{
 *   closeSidebar: () => void,
 *   isCollapsed: boolean,
 *   onNotImplemented: () => void,
 * }} NavShellContextValue
 */

/** @type {React.Context<NavShellContextValue | null>} */
const NavShellContext = createContext(null)

/**
 * @param {{ value: NavShellContextValue, children: React.ReactNode }} props
 */
export function NavShellProvider({ value, children }) {
    return React.createElement(NavShellContext.Provider, { value }, children)
}

export function useNavShell() {
    const ctx = useContext(NavShellContext)
    if (!ctx) {
        throw new Error("useNavShell must be used within NavShellProvider")
    }
    return ctx
}

